import { render, staticRenderFns } from "./yek-opintoopas-form.vue?vue&type=template&id=f0e2abc0&scoped=true&"
import script from "./yek-opintoopas-form.vue?vue&type=script&lang=ts&"
export * from "./yek-opintoopas-form.vue?vue&type=script&lang=ts&"
import style0 from "./yek-opintoopas-form.vue?vue&type=style&index=0&id=f0e2abc0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0e2abc0",
  null
  
)

export default component.exports